import React from 'react';
import './ActiveAssets.scss';

const ActiveAssets: React.FC = () => {
  return (
    <div className="active-assets">
      <h3>Aktive Assets</h3>
      <p>Übersicht der wirtschaftlich aktiven Anlagen.</p>
    </div>
  );
};

export default ActiveAssets;